import { c as o } from "./createLucideIcon-Bs_bgX_W.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], t = o("x", c);
export {
  t as X
};
//# sourceMappingURL=x-Bns8qHU3.js.map
